import ServerLogs from './logs'
export default ServerLogs
